import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetOtherMediumsResponse = string[];

/**
 * サイクル設定他媒体情報取得サービス
 * @export GetOtherMediumsService
 * @class GetOtherMediumsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOtherMediumsService extends PlessJsonResponderSub<GetOtherMediumsResponse> {
  model: KYMW1200Model;
  medium: string;
  pcode: string;
  order: string;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOtherMediumsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.medium,
        OrderCode: this.order,
        PCode: this.pcode,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param medium 媒体区分
   * @param pcode Pコード
   * @param order 受注コード
   * @param model
   * @param f
   * @memberof GetOtherMediumsService
   */
  execute(
    medium: string,
    pcode: string,
    order: string,
    model: KYMW1200Model,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.medium = medium;
    this.pcode = pcode;
    this.order = order;
    this.model.otherMediums = [];
    this.succeed = s;
    this.fail = f;
    this.send('getOtherMediums', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOtherMediumsService
   */
  success(data: GetOtherMediumsResponse) {
    this.model.otherMediums = data;
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param medium
   * @param pcode
   * @param order
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(
    medium: string,
    pcode: string,
    order: string,
    model: KYMW1200Model
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        medium,
        pcode,
        order,
        model,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
